import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import Loader from '@/components/common/Loader'

const UploadComparisonPage = lazy(async () => {
  const module = await import('@/features/city-clerk/document-comparison')
  return { default: module.UploadComparisonPage }
})

export const Route = createFileRoute('/(app)/city-clerk/$id/compare/')({
  component: CompareRouteComponent,
  pendingComponent: () => (
    <div className="h-page bg-(--color-surface) flex items-center justify-center z-9999">
      <Loader size="lg" />
    </div>
  ),
})

function CompareRouteComponent() {
  return (
    <Suspense
      fallback={
        <div className="h-page bg-(--color-surface) flex items-center justify-center z-9999">
          <Loader size="lg" />
        </div>
      }
    >
      <UploadComparisonPage />
    </Suspense>
  )
}
